// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import donationExpenseEntity from './entities/donation-expense.json';
import donationExpenseMenu from '../pages/donation-expense/menu.json';
import donationExpenseFullForm from '../pages/donation-expense/forms/full.json';
import donationExpenseContextForm from '../pages/donation-expense/forms/context.json';
import donationExpenseMiniForm from '../pages/donation-expense/forms/mini.json';
import donationExpenseLookupForm from '../pages/donation-expense/forms/lookup.json';
import donationExpenseTableView from '../pages/donation-expense/views/table.json';
import donationExpenseCardsView from '../pages/donation-expense/views/cards.json';
import donationExpenseDashboardView from '../pages/donation-expense/views/dashboard.json';

/** Тип запису «Видаток» зі сторінками пакета: меню, форми та подання з pages/donation-expense/. */
export const donationExpenseDefinition: IRecordTypeDefinition = {
  ...donationExpenseEntity,
  views: assembleViewSet({
      table: donationExpenseTableView,
      cards: donationExpenseCardsView,
      dashboard: donationExpenseDashboardView,
  }),
  form: donationExpenseFullForm,
  forms: { full: donationExpenseFullForm, context: donationExpenseContextForm, mini: donationExpenseMiniForm, lookup: donationExpenseLookupForm },
  menu: donationExpenseMenu,
} as IRecordTypeDefinition;
